import {logSources} from "@/dictionaries/dictionary"

export default {
    primaryKey: "id",
    model: 'log',
    order: 'id',
    sort: 'desc',
    actions: [],
    fields: [
        {
            id: 'id',
            title: 'id',
            table: true,
            sortable: true
        },
        {
            id: 'subject_id',
            title: 'model_id',
            table: true,
            sortable: true,
            filter: true,
        },
        {
            id: 'subject_type',
            title: 'model_type',
            table: true,
            sortable: true,
            tdcomponent: 'LogsDatatableTDModelType',
            filter: true,
            filter_list_select: true,
            form: {
                options: {
                    'Manager': { id: 'App\\Models\\Users\\Manager', title: 'Manager' },
                    'DoctorAssistant': { id: 'App\\Models\\Users\\DoctorAssistant', title: 'DoctorAssistant' },
                    'Doctor': { id: 'App\\Models\\Users\\Doctor', title: 'Doctor' },
                    'Record': { id: 'App\\Models\\Specific\\Treatment\\Record', title: 'Record' },
                    'Payment': { id: 'App\\Models\\Specific\\Accounting\\Payment', title: 'Payment' },
                    'Advance': { id: 'App\\Models\\Specific\\Accounting\\Advance', title: 'Advance' },
                    'Service': { id: 'App\\Models\\Specific\\Treatment\\Service', title: 'Service' },
                    'Kit': { id: 'App\\Models\\Specific\\Warehouse\\Kit', title: 'Kit' },
                    'Patient': { id: 'App\\Models\\Users\\Patient', title: 'Patient' },
                    'PlanTreatment': { id: 'App\\Models\\Specific\\Treatment\\PlanTreatment', title: 'PlanTreatment' },
                    'LaboratoryOrder': { id: 'App\\Models\\Specific\\Laboratories\\LaboratoryOrder', title: 'LaboratoryOrder' },
                    'DynamicConfig': { id: 'App\\Models\\Specific\\Clinic\\DynamicConfig', title: 'DynamicConfig' },
                    'User': { id: 'App\\Models\\Users\\User', title: 'User' },
                    'Curator': { id: 'App\\Models\\Users\\Curator', title: 'Curator' },
                    'Technic': { id: 'App\\Models\\Users\\Technic', title: 'Technic' },
                    'SuperManager': { id: 'App\\Models\\Users\\SuperManager', title: 'SuperManager' },
                    'UserAdditional': { id: 'App\\Models\\Users\\UserAdditional', title: 'UserAdditional' },
                    'CustomRole': { id: 'App\\Models\\Users\\CustomRole', title: 'CustomRole' },
                    'PlanSession': { id: 'App\\Models\\Specific\\Treatment\\PlanSession', title: 'PlanSession' },
                    'ComplexService': { id: 'App\\Models\\Specific\\Treatment\\ComplexService', title: 'ComplexService' },
                    'Price': { id: 'App\\Models\\Specific\\Treatment\\Price', title: 'Price' },
                    'RecordTooth': { id: 'App\\Models\\Specific\\Treatment\\RecordTooth', title: 'RecordTooth' },
                    'Scan': { id: 'App\\Models\\Specific\\Treatment\\Scan', title: 'Scan' },
                    'ClientNote': { id: 'App\\Models\\Specific\\Treatment\\ClientNote', title: 'ClientNote' },
                    'EGISZRecord': { id: 'App\\Models\\Specific\\Treatment\\EGISZRecord', title: 'EGISZRecord' },
                    'ClientDocument': { id: 'App\\Models\\Specific\\Patient\\ClientDocument', title: 'ClientDocument' },
                    'ClientTag': { id: 'App\\Models\\Specific\\Patient\\ClientTag', title: 'ClientTag' },
                    'GeneratedDocument': { id: 'App\\Models\\Specific\\Patient\\GeneratedDocument', title: 'GeneratedDocument' },
                    'PatientComment': { id: 'App\\Models\\Specific\\Patient\\PatientComment', title: 'PatientComment' },
                    'AgreementDocument': { id: 'App\\Models\\Specific\\Documents\\AgreementDocument', title: 'AgreementDocument' },
                    'DogovorDocument': { id: 'App\\Models\\Specific\\Documents\\DogovorDocument', title: 'DogovorDocument' },
                    'DepositByAccount': { id: 'App\\Models\\Specific\\Accounting\\DepositByAccount', title: 'DepositByAccount' },
                    'StaffWork': { id: 'App\\Models\\Specific\\Accounting\\StaffWork', title: 'StaffWork' },
                    'ClinicAdditional': { id: 'App\\Models\\Specific\\Clinic\\ClinicAdditional', title: 'ClinicAdditional' },
                    'ClinicTariff': { id: 'App\\Models\\Specific\\Billing\\ClinicTariff', title: 'ClinicTariff' },
                    'DoctorScheduleConfiguration': { id: 'App\\Models\\Specific\\Doctor\\DoctorScheduleConfiguration', title: 'DoctorScheduleConfiguration' },
                    'NotificationSetting': { id: 'App\\Models\\Specific\\Notifications\\NotificationSetting', title: 'NotificationSetting' },
                    'NotificationWaitingResponse': { id: 'App\\Models\\Specific\\Notifications\\NotificationWaitingResponse', title: 'NotificationWaitingResponse' },
                    'WarehouseOperation': { id: 'App\\Models\\Specific\\Warehouse\\WarehouseOperation', title: 'WarehouseOperation' },
                    'WarehouseInventarizationSheet': { id: 'App\\Models\\Specific\\Warehouse\\WarehouseInventarizationSheet', title: 'WarehouseInventarizationSheet' },
                }
            },
        },
        {
            id: 'causer_id',
            title: 'user_id',
            table: true,
            sortable: true,
            table_show: ['causer_id', 'causer.full_name'],
            // table_show: 'causer_id',
            filter: true
        },
        {
            id: 'properties',
            table_show: 'logEnriched',
            title: 'data',
            table: true,
            sortable: true,
            filter: true,
            tdcomponent: 'JsonPrettifyTD',
        },
        {
            id: 'description',
            title: 'description',
            table: true,
            sortable: true,
            format_translate: true,
            filter_list_select: true,
            form: {
                options: {
                    'created': { id: 'created', title: 'created' },
                    'updated': { id: 'updated', title: 'updated' },
                    'deleted': { id: 'deleted', title: 'deleted' },
                    'logged': { id: 'logged', title: 'logged' },
                    'visit services sync': { id: 'visit services sync', title: 'visit services sync' },
                    'exported_patients_to_excel': { id: 'exported_patients_to_excel', title: 'exported_patients_to_excel' },
                    'exported_report_to_excel': { id: 'exported_report_to_excel', title: 'exported_report_to_excel' },
                    'patient_tags_updated': { id: 'patient_tags_updated', title: 'patient_tags_updated' },
                    'family_account_updated': { id: 'family_account_updated', title: 'family_account_updated' },
                    'family_account_member_toggled': { id: 'family_account_member_toggled', title: 'family_account_member_toggled' },
                    'logged_out': { id: 'logged_out', title: 'logged_out' },
                    'session_revoked': { id: 'session_revoked', title: 'session_revoked' },
                    'sessions_revoked': { id: 'sessions_revoked', title: 'sessions_revoked' },
                    'password_reset_requested': { id: 'password_reset_requested', title: 'password_reset_requested' },
                    'password_reset_succeeded': { id: 'password_reset_succeeded', title: 'password_reset_succeeded' },
                    'password_reset_failed': { id: 'password_reset_failed', title: 'password_reset_failed' },
                    'password_changed': { id: 'password_changed', title: 'password_changed' },
                    'login_failed': { id: 'login_failed', title: 'login_failed' },
                    'login_locked_out': { id: 'login_locked_out', title: 'login_locked_out' },
                    'custom_role_rights_updated': { id: 'custom_role_rights_updated', title: 'custom_role_rights_updated' },
                    'staff_rights_updated': { id: 'staff_rights_updated', title: 'staff_rights_updated' },
                    'staff_role_updated': { id: 'staff_role_updated', title: 'staff_role_updated' },
                    'egisz_send_success': { id: 'egisz_send_success', title: 'egisz_send_success' },
                    'egisz_send_error': { id: 'egisz_send_error', title: 'egisz_send_error' },
                }
            },
            filter: true
        },
        {
            id: 'ip',
            title: 'IP',
            table: true,
            sortable: false,
            filter: false
        },
        {
            id: 'source',
            title: 'source',
            table: true,
            sortable: false,
            filter: true,
            filter_list_select: true,
            form: {
                options: logSources
            }
        },
        {
            id: 'created_at',
            title: 'date',
            table: true,
            sortable: true,
            format_datetime: true,
            filter: true
        }
    ]
}
